import React, { Component } from 'react';
import HotelContractPage from './hotel-contracts-html';
import { contractServices } from '../../../../../../_services';
import $ from "jquery";
import { toast } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";

// import Pagination from 'react-js-pagination';

class HotelContract extends Component {
  constructor(props) {
    super(props)
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.companyId = localStorage["440a28"];
    this.validator = new SimpleReactValidator();
  }
  state = {
    limit: 10,
    selectedPage: 1,
    selectedId: "",
    paymentTypeList: [],
    totalCount: "",
    pageItemsList: [{ items: 10 }, { items: 20 }, { items: 30 }],
    search: "",
    companyId: localStorage["440a28"],
    page: 1,
    cityList: [],
    isSearchCityListOpen: true,
    selectedCity: {
      name: "",
      id: ""
    },
    cityHotels: [],
    removeCity: "",
    removeButton: false,
    editCity: false,
    isLoading: true,
  }

  componentDidMount() {
    let cityData = {
      companyId: this.state.companyId,
      limit: this.state.limit,
      page: this.state.page
    }
    this.getHotelDetailsInCity(cityData);
  }
  handleChangeCity = async (e) => {
    let searchTerm = e.target.value;
    try {
      if (searchTerm != '') {
        // * if the user is typing show the matched search users.
        this.setState({
          isSearchCityListOpen: true,
          selectedCity: {
            name: e.target.value
          }
        });

        let res = await contractServices.getCityList(searchTerm);

        if (res && res.count) {
          console.log('search results are ', res);
          this.setState({
            cityList: res.result
          })

        }
      } else {
        this.setState({ cityList: [], selectedCity: {} });
      }

    } catch (err) {
      console.log('some error occurred.');
    }

  }

  selectChangeCity = (city) => {
    let selectedCity = {
      name: city.city,
      id: city.id
    }
    this.setState({
      selectedCity,
      isSearchCityListOpen: false
    });
  }
  saveTheSelectedCity = async (e) => {
    e.preventDefault();
    let data = {
      cityId: this.state.selectedCity.id,
      cityName: this.state.selectedCity.name,
      companyId: this.state.companyId
    };

    if (this.validator.allValid()) {
      var resp = await contractServices.saveTheSelectedCity(data);
      if (resp) {
        $(".close").click();
        toast.success(resp.message);
        let cityData = {
          companyId: this.state.companyId,
          limit: this.state.limit,
          page: this.state.page
        }
        this.getHotelDetailsInCity(cityData);
      }

    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }

  getHotelDetailsInCity = async (data) => {
    this.setState({ isLoading: true });
    var res = await contractServices.getHotelDetailsInCity(data);
    if (res) {
      this.setState({ isLoading: false });
      this.setState({ cityHotels: res.result, totalCount: res.count })
    }
  }

  onStatusChangeHandler = async (id, activeStatus) => {
    let data = {
      activeStatus
    }
    var res = await contractServices.onStatusChangeHandler(id, data);
    if (res) {
      let cityData = {
        companyId: this.state.companyId,
        limit: this.state.limit,
        page: this.state.page
      }
      this.getHotelDetailsInCity(cityData);
      toast.success(res.message);
    }
  };
  removeCityHandler = async () => {
    let deleteId = this.state.removeCity;
    var res = await contractServices.removeCityHandler(deleteId);
    if (res) {
      let cityData = {
        companyId: this.state.companyId,
        limit: this.state.limit,
        page: this.state.page
      }
      this.getHotelDetailsInCity(cityData);
      this.setState({ removeCity: "", removeButton: false });
      toast.success(res.message);
    }
  };
  onDeleteHandler = city => {
    let removeCity = this.state.removeCity;
    if (removeCity === city) {
      this.setState({ removeCity: "", removeButton: false });
    } else {
      this.setState({ removeCity: city, removeButton: true });
    }
  };


  onSearchTextChangeHandler = async (event) => {
    let search = event.target.value;
    if (search !== '' && search !== '') {
      await this.setState({ search: event.target.value });
      let response = await contractServices.getHotelDetailsSearch(this.state.companyId, search);
      if (response.count > 0) {
        this.setState({
          cityHotels: response.result,
          totalCount: response.count
        });
      } else {
        this.setState({
          cityHotels: []
        });
      }
    } else {
      this.setState({ search: '' });
      let cityData = {
        companyId: this.state.companyId,
        limit: this.state.limit,
        page: this.state.page
      }
      this.getHotelDetailsInCity(cityData);
    }
  }
  handleItemChange = limit => {
    this.setState({ limit: limit["items"], selectedPage: 1 })
    let data = {
      companyId: this.state.companyId,
      limit: limit["items"],
      page: this.state.selectedPage
    }
    this.getHotelDetailsInCity(data);
  };
  render() {
    return (
      <div>
        <HotelContractPage
          {...this.state}
          state={this.state}
          onStatusChangeHandler={this.onStatusChangeHandler}
          onDeleteHandler={this.onDeleteHandler}
          removeCityHandler={this.removeCityHandler}
          handleChangeCity={this.handleChangeCity}
          selectChangeCity={this.selectChangeCity}
          saveTheSelectedCity={this.saveTheSelectedCity}
          validator={this.validator}
          editCityName={this.editCityName}
          saveTheEditedCity={this.saveTheEditedCity}
          onSearchTextChangeHandler={this.onSearchTextChangeHandler}
          handleItemChange={this.handleItemChange}
        />
      </div>
    )
  }
}

export default HotelContract;
